export default __webpack_public_path__ + "static/media/1748_1892_övrig_plywood.99ce915b.JPG";